import { gql } from '@apollo/client'

export const createGrantRequest = gql`
  mutation CreateGrantRequest($data: CreateGrantRequestInput!) {
    createGrantRequest(data: $data) {
      id
      grantNote
      amount
      tip
      createdAt
      updatedAt
      anonymous
      processingNote
      checkNumber
      checkClearedAt
      processingDate
      paymentType
    }
  }
`

export const userUpdateRecurrentGrantRequest = gql`
  mutation userUpdateRecurrentGrantRequest($data: UpdateRecurrentGrantRequestInput!) {
    userUpdateRecurrentGrantRequest(data: $data) {
      id
    }
  }
`

export const cancelRecurringGrantRequest = gql`
  mutation cancelRecurrentGrantRequest($id: Int!, $fundId: Int!) {
    cancelRecurrentGrantRequest(id: $id, fundId: $fundId) {
      id
      nextScheduledGrant
      state
    }
  }
`

export const cancelPendingGrantRequest = gql`
  mutation cancelPendingGrantRequest($id: Int!, $fundId: Int!) {
    cancelPendingGrantRequest(id: $id, fundId: $fundId) {
      id
      state
    }
  }
`
